// This file is automatically generated by the "generate-timezones-file" script
// DO NOT MODIFY THIS FILE BY HAND. THE CHANGES WILL BE OVERWRITTEN!
export default {
  'Africa/Abidjan': [
    'Africa/Bamako',
    'Africa/Banjul',
    'Africa/Conakry',
    'Africa/Dakar',
    'Africa/Freetown',
    'Africa/Lome',
    'Africa/Nouakchott',
    'Africa/Ouagadougou',
    'Africa/Timbuktu',
    'Atlantic/St_Helena',
  ],
  'Africa/Cairo': ['Egypt'],
  'Africa/Johannesburg': ['Africa/Maseru', 'Africa/Mbabane'],
  'Africa/Lagos': [
    'Africa/Bangui',
    'Africa/Brazzaville',
    'Africa/Douala',
    'Africa/Kinshasa',
    'Africa/Libreville',
    'Africa/Luanda',
    'Africa/Malabo',
    'Africa/Niamey',
    'Africa/Porto-Novo',
  ],
  'Africa/Maputo': [
    'Africa/Blantyre',
    'Africa/Bujumbura',
    'Africa/Gaborone',
    'Africa/Harare',
    'Africa/Kigali',
    'Africa/Lubumbashi',
    'Africa/Lusaka',
  ],
  'Africa/Nairobi': [
    'Africa/Addis_Ababa',
    'Africa/Asmara',
    'Africa/Asmera',
    'Africa/Dar_es_Salaam',
    'Africa/Djibouti',
    'Africa/Kampala',
    'Africa/Mogadishu',
    'Indian/Antananarivo',
    'Indian/Comoro',
    'Indian/Mayotte',
  ],
  'Africa/Tripoli': ['Libya'],
  'America/Adak': ['America/Atka', 'US/Aleutian'],
  'America/Anchorage': ['US/Alaska'],
  'America/Argentina/Buenos_Aires': ['America/Buenos_Aires'],
  'America/Argentina/Catamarca': ['America/Argentina/ComodRivadavia', 'America/Catamarca'],
  'America/Argentina/Cordoba': ['America/Cordoba', 'America/Rosario'],
  'America/Argentina/Jujuy': ['America/Jujuy'],
  'America/Argentina/Mendoza': ['America/Mendoza'],
  'America/Atikokan': ['America/Coral_Harbour'],
  'America/Chicago': ['US/Central'],
  'America/Curacao': ['America/Aruba', 'America/Kralendijk', 'America/Lower_Princes'],
  'America/Denver': ['America/Shiprock', 'Navajo', 'US/Mountain'],
  'America/Detroit': ['US/Michigan'],
  'America/Edmonton': ['Canada/Mountain'],
  'America/Halifax': ['Canada/Atlantic'],
  'America/Havana': ['Cuba'],
  'America/Indiana/Indianapolis': ['America/Fort_Wayne', 'America/Indianapolis', 'US/East-Indiana'],
  'America/Indiana/Knox': ['America/Knox_IN', 'US/Indiana-Starke'],
  'America/Jamaica': ['Jamaica'],
  'America/Kentucky/Louisville': ['America/Louisville'],
  'America/Los_Angeles': ['US/Pacific'],
  'America/Manaus': ['Brazil/West'],
  'America/Mazatlan': ['Mexico/BajaSur'],
  'America/Mexico_City': ['Mexico/General'],
  'America/New_York': ['US/Eastern'],
  'America/Noronha': ['Brazil/DeNoronha'],
  'America/Nuuk': ['America/Godthab'],
  'America/Panama': ['America/Cayman'],
  'America/Phoenix': ['US/Arizona'],
  'America/Port_of_Spain': [
    'America/Anguilla',
    'America/Antigua',
    'America/Dominica',
    'America/Grenada',
    'America/Guadeloupe',
    'America/Marigot',
    'America/Montserrat',
    'America/St_Barthelemy',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/St_Thomas',
    'America/St_Vincent',
    'America/Tortola',
    'America/Virgin',
  ],
  'America/Regina': ['Canada/Saskatchewan'],
  'America/Rio_Branco': ['America/Porto_Acre', 'Brazil/Acre'],
  'America/Santiago': ['Chile/Continental'],
  'America/Sao_Paulo': ['Brazil/East'],
  'America/St_Johns': ['Canada/Newfoundland'],
  'America/Tijuana': ['America/Ensenada', 'America/Santa_Isabel', 'Mexico/BajaNorte'],
  'America/Toronto': ['America/Montreal', 'Canada/Eastern'],
  'America/Vancouver': ['Canada/Pacific'],
  'America/Whitehorse': ['Canada/Yukon'],
  'America/Winnipeg': ['Canada/Central'],
  'Asia/Ashgabat': ['Asia/Ashkhabad'],
  'Asia/Bangkok': ['Asia/Phnom_Penh', 'Asia/Vientiane'],
  'Asia/Dhaka': ['Asia/Dacca'],
  'Asia/Dubai': ['Asia/Muscat'],
  'Asia/Ho_Chi_Minh': ['Asia/Saigon'],
  'Asia/Hong_Kong': ['Hongkong'],
  'Asia/Jerusalem': ['Asia/Tel_Aviv', 'Israel'],
  'Asia/Kathmandu': ['Asia/Katmandu'],
  'Asia/Kolkata': ['Asia/Calcutta'],
  'Asia/Macau': ['Asia/Macao'],
  'Asia/Makassar': ['Asia/Ujung_Pandang'],
  'Asia/Nicosia': ['Europe/Nicosia'],
  'Asia/Qatar': ['Asia/Bahrain'],
  'Asia/Riyadh': ['Asia/Aden', 'Asia/Kuwait'],
  'Asia/Seoul': ['ROK'],
  'Asia/Shanghai': ['Asia/Chongqing', 'Asia/Chungking', 'Asia/Harbin', 'PRC'],
  'Asia/Singapore': ['Singapore'],
  'Asia/Taipei': ['ROC'],
  'Asia/Tehran': ['Iran'],
  'Asia/Thimphu': ['Asia/Thimbu'],
  'Asia/Tokyo': ['Japan'],
  'Asia/Ulaanbaatar': ['Asia/Ulan_Bator'],
  'Asia/Urumqi': ['Asia/Kashgar'],
  'Asia/Yangon': ['Asia/Rangoon'],
  'Atlantic/Faroe': ['Atlantic/Faeroe'],
  'Atlantic/Reykjavik': ['Iceland'],
  'Australia/Adelaide': ['Australia/South'],
  'Australia/Brisbane': ['Australia/Queensland'],
  'Australia/Broken_Hill': ['Australia/Yancowinna'],
  'Australia/Darwin': ['Australia/North'],
  'Australia/Hobart': ['Australia/Currie', 'Australia/Tasmania'],
  'Australia/Lord_Howe': ['Australia/LHI'],
  'Australia/Melbourne': ['Australia/Victoria'],
  'Australia/Perth': ['Australia/West'],
  'Australia/Sydney': ['Australia/ACT', 'Australia/Canberra', 'Australia/NSW'],
  'Etc/GMT': [
    'Etc/GMT+0',
    'Etc/GMT-0',
    'Etc/GMT0',
    'Etc/Greenwich',
    'GMT',
    'GMT+0',
    'GMT-0',
    'GMT0',
    'Greenwich',
  ],
  'Etc/UTC': ['Etc/UCT', 'Etc/Universal', 'Etc/Zulu', 'UCT', 'UTC', 'Universal', 'Zulu'],
  'Europe/Belgrade': [
    'Europe/Ljubljana',
    'Europe/Podgorica',
    'Europe/Sarajevo',
    'Europe/Skopje',
    'Europe/Zagreb',
  ],
  'Europe/Chisinau': ['Europe/Tiraspol'],
  'Europe/Dublin': ['Eire'],
  'Europe/Helsinki': ['Europe/Mariehamn'],
  'Europe/Istanbul': ['Asia/Istanbul', 'Turkey'],
  'Europe/Lisbon': ['Portugal'],
  'Europe/London': [
    'Europe/Belfast',
    'Europe/Guernsey',
    'Europe/Isle_of_Man',
    'Europe/Jersey',
    'GB',
    'GB-Eire',
  ],
  'Europe/Moscow': ['W-SU'],
  'Europe/Oslo': ['Arctic/Longyearbyen', 'Atlantic/Jan_Mayen'],
  'Europe/Prague': ['Europe/Bratislava'],
  'Europe/Rome': ['Europe/San_Marino', 'Europe/Vatican'],
  'Europe/Warsaw': ['Poland'],
  'Europe/Zurich': ['Europe/Busingen', 'Europe/Vaduz'],
  'Pacific/Auckland': ['Antarctica/McMurdo', 'Antarctica/South_Pole', 'NZ'],
  'Pacific/Chatham': ['NZ-CHAT'],
  'Pacific/Chuuk': ['Pacific/Truk', 'Pacific/Yap'],
  'Pacific/Easter': ['Chile/EasterIsland'],
  'Pacific/Guam': ['Pacific/Saipan'],
  'Pacific/Honolulu': ['Pacific/Johnston', 'US/Hawaii'],
  'Pacific/Kwajalein': ['Kwajalein'],
  'Pacific/Pago_Pago': ['Pacific/Midway', 'Pacific/Samoa', 'US/Samoa'],
  'Pacific/Pohnpei': ['Pacific/Ponape'],
} as Record<string, string[]>
